import { render, staticRenderFns } from "./profile-image-preview.vue?vue&type=template&id=f885a65a&scoped=true&"
import script from "./profile-image-preview.vue?vue&type=script&lang=ts&"
export * from "./profile-image-preview.vue?vue&type=script&lang=ts&"
import style0 from "./profile-image-preview.vue?vue&type=style&index=0&id=f885a65a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f885a65a",
  null
  
)

export default component.exports